import { SxProps, Theme } from '@mui/material'
import { HeaderColorScheme, HEADER_COLOR_SCHEME } from './headerColorVariants'

export const headerHeight = '6rem'

export const mobileHeaderLogoRowHeight = '4.4rem'

export const mobileHeaderActionsRowHeight = '4.4rem'

export const headerSecondaryHeight = '4.4rem'

export const headerNavSectionPadding = { xs: 1, md: 2 }

export const headerNavTextPaddingStart = '1.8rem'

export const getHeaderPrimaryTabsSx = (scheme: HeaderColorScheme): SxProps<Theme> => ({
  backgroundColor: 'transparent',
  height: '100%',
  minHeight: headerHeight,
  overflow: 'visible',
  pl: 0,
  position: 'relative',
  zIndex: 1,
  '& .MuiTabs-flexContainer': {
    alignItems: 'stretch',
    height: '100%',
  },
  '& .MuiTabs-scroller': {
    height: '100%',
  },
  '& .MuiTabs-indicator': {
    backgroundColor: scheme.tabIndicator,
    bottom: '-1px',
    height: '.3rem',
    zIndex: 1,
  },
  '& .MuiTabs-scrollButtons': {
    color: scheme.scrollButtonColor,
  },
})

export const getHeaderPrimaryTabSx = (scheme: HeaderColorScheme): SxProps<Theme> => ({
  color: scheme.tabText,
  fontSize: '1.2rem',
  fontWeight: 700,
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  minHeight: headerHeight,
  minWidth: 0,
  padding: `0 ${headerNavTextPaddingStart}`,
  whiteSpace: 'nowrap',
  transition: 'background-color 0.15s ease, color 0.15s ease',
  '&:hover': {
    backgroundColor: scheme.tabHoverBackground,
    color: scheme.tabTextHover,
  },
  '&.Mui-selected': {
    backgroundColor: scheme.tabSelectedBackground,
    color: scheme.tabSelectedText,
  },
})

export const headerPrimaryTabsSx = getHeaderPrimaryTabsSx(HEADER_COLOR_SCHEME)

export const headerPrimaryTabSx = getHeaderPrimaryTabSx(HEADER_COLOR_SCHEME)

export const headerSecondaryTabsSx: SxProps<Theme> = {
  backgroundColor: 'header',
  minHeight: headerSecondaryHeight,
  overflow: 'visible',
  position: 'relative',
  zIndex: 1,
  '& .MuiTabs-indicator': {
    bottom: '-1px',
    height: '.3rem',
    zIndex: 1,
  },
  '& .MuiTabs-scrollButtons': {
    color: 'text.secondary',
  },
}

export const headerSecondaryTabSx: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: '1.2rem',
  fontWeight: 700,
  minHeight: headerSecondaryHeight,
  minWidth: 0,
  padding: '0 1.6rem',
  whiteSpace: 'nowrap',
  '&.Mui-selected': {
    color: 'text.primary',
  },
}
